"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  common: {
    ok: 'OK',
    error: 'Błąd',
    errorTitle: 'Błąd',
    success: 'Sukces',
    unexpectedError: 'Przepraszamy, wystąpił nieoczekiwany błąd. Prosimy spróbować ponownie później.'
  },
  imageDocumentPreview: {
    error: 'Podgląd obrazu niedostępny'
  },
  pdfDocumentPreview: {
    pdfError: 'Podgląd pliku PDF niedostępny',
    empty: 'Brak pliku'
  },
  date: {
    rangeFilterName: 'Zakres dat',
    any: 'Dowolny czas',
    startDate: 'Data rozpoczęcia',
    endDate: 'Data zakończenia',
    rangeSeparator: 'do',
    placeholder: 'Data',
    presets: {
      today: 'Dzisiaj',
      thisWeek: 'Ten tydzień',
      lastWeek: 'Poprzedni tydzień',
      thisMonth: 'Ten miesiąc',
      lastMonth: 'Poprzedni miesiąc'
    }
  },
  tableFooter: {
    showing: 'Wyświetlanie od {{pageStart}} do {{pageEnd}} z {{totalItemsCount}} {{dataName}}',
    mobileShowing: 'Wyświetlanie od {{pageStart}} - {{pageEnd}} {{dataName}}'
  },
  emailBox: {
    emailInvoice: 'Wyślij nam swoją fakturę (dostawcy mogą również z tego korzystać):',
    emailSupliersCompleteData: 'Wyślij dostawcom link do uzupełnienia ich danych:',
    emailSupliersSendQuote: 'Wyślij dostawcom link do wysłania wyceny:',
    copied: 'Skopiowano!'
  },
  amountCell: {
    converted: 'Przekonwertowane:'
  },
  addFiltersToggle: {
    add: 'Dodaj filtry'
  },
  filtersLayout: {
    search: 'Szukaj...'
  },
  settingsLayout: {
    title: 'Ustawienia'
  },
  reportsLayout: {
    title: 'Raporty'
  },
  additionalFiltersLayout: {
    filterBy: 'Filtruj według',
    apply: 'Zastosuj filtry',
    clear: 'Wyczyść filtry'
  },
  fileUploader: {
    buttonText: 'Prześlij plik',
    fileSizeError: 'Rozmiar pliku nie może przekraczać {{maxSizeMb}}MB.',
    defaultEmptyText: 'Nie wybrano pliku'
  },
  fileDropZone: {
    remove: 'Usuń',
    browse: 'lub przeglądaj tutaj'
  },
  statusLabel: {
    approved: 'ZATWIERDZONE',
    pending: 'OCZEKUJĄCE',
    awaitingApproval: 'OCZEKUJĄCE NA ZATWIERDZENIE',
    notSubmitted: 'NIE ZGŁOSZONE',
    draft: 'SZKIC',
    cancelled: 'ANULOWANE',
    declined: 'ODRZUCONE',
    completed: 'ZAKOŃCZONE'
  },
  errors: {
    pageNotFound: 'Ta strona nie może zostać znaleziona.',
    unexpectedError: 'Coś poszło nie tak. Prosimy o kontakt z pomocą techniczną.',
    returnToLogin: 'Powrót do logowania',
    error: 'Błąd',
    uiSettingsIssue: 'Wystąpił problem z ustawieniami interfejsu.'
  },
  inputPassword: {
    hide: 'Ukryj',
    show: 'Pokaż'
  },
  inputAmount: {
    popularGroup: 'Popularne',
    otherGroup: 'Inne'
  },
  phonePicker: {
    searchPlaceholder: 'Wpisz, aby wyszukać...',
    noCountriesText: 'Nie znaleziono krajów'
  },
  multiPhonePicker: {
    addNewLabel: 'Dodaj dodatkowy numer telefonu'
  },
  formField: {
    optional: '(Opcjonalne)'
  },
  dateCell: {
    futurePayment: 'Przyszła płatność'
  },
  multiSearchSelect: {
    all: 'Wszystkie',
    selectAll: 'Zaznacz wszystkie',
    deselectAll: 'Odznacz wszystkie',
    noOptions: 'Nie znaleziono opcji'
  },
  currencies: {
    AED: 'Dirham Zjednoczonych Emiratów Arabskich',
    AFN: 'Afgani afgański',
    ALL: 'Lek albański',
    AMD: 'Dram armeński',
    ANG: 'Gulden Antyli Holenderskich',
    AOA: 'Kwanza angolska',
    ARS: 'Peso argentyńskie',
    AUD: 'Dolar australijski',
    AWG: 'Florin arubański',
    AZN: 'Manat azerski',
    BAM: 'Marka zamienna Bośni i Hercegowiny',
    BBD: 'Dolar barbadoski',
    BDT: 'Taka bengalska',
    BGN: 'Lew bułgarski',
    BHD: 'Dinar bahrański',
    BIF: 'Frank burundyjski',
    BMD: 'Dolar bermudzki',
    BND: 'Dolar brunejski',
    BOB: 'Boliviano',
    BRL: 'Real brazylijski',
    BSD: 'Dolar bahamski',
    BTN: 'Ngultrum bhutański',
    BWP: 'Pula botswańska',
    BYN: 'Rubel białoruski',
    BZD: 'Dolar belizeński',
    CAD: 'Dolar kanadyjski',
    CDF: 'Frank kongijski',
    CHF: 'Frank szwajcarski',
    CLP: 'Peso chilijskie',
    CNY: 'Juan chiński',
    COP: 'Peso kolumbijskie',
    CRC: 'Colon kostarykański',
    CUC: 'Peso kubańskie wymienialne',
    CVE: 'Escudo Zielonego Przylądka',
    CZK: 'Korona czeska',
    DJF: 'Frank dżibutyjski',
    DKK: 'Korona duńska',
    DOP: 'Peso dominikańskie',
    DZD: 'Dinar algierski',
    EGP: 'Funt egipski',
    ERN: 'Nakfa erytrejska',
    ETB: 'Birr etiopski',
    EUR: 'Euro',
    FJD: 'Dolar fidżyjski',
    FKP: 'Funt Wysp Falklandzkich',
    GBP: 'Funt brytyjski',
    GEL: 'Lari gruziński',
    GHS: 'Cedi ghański',
    GIP: 'Funt gibraltarski',
    GMD: 'Dalasi gambijski',
    GNF: 'Frank gwinejski',
    GTQ: 'Keczał gwatemalski',
    GYD: 'Dolar gujański',
    HKD: 'Dolar hongkoński',
    HNL: 'Lempira honduraska',
    HRK: 'Kuna chorwacka',
    HTG: 'Gourde haitańskie',
    HUF: 'Forint węgierski',
    IDR: 'Rupia indonezyjska',
    ILS: 'Szekel izraelski',
    INR: 'Rupia indyjska',
    IQD: 'Dinar iracki',
    IRR: 'Rial irański',
    ISK: 'Korona islandzka',
    JMD: 'Dolar jamajski',
    JOD: 'Dinar jordański',
    JPY: 'Jen japoński',
    KES: 'Szyling kenijski',
    KGS: 'Som kirgiski',
    KHR: 'Riel kambodżański',
    KMF: 'Frank Komorów',
    KPW: 'Won północnokoreański',
    KRW: 'Won południowokoreański',
    KWD: 'Dinar kuwejcki',
    KYD: 'Dolar kajmański',
    KZT: 'Tenge kazachskie',
    LAK: 'Kip laotański',
    LBP: 'Funt libański',
    LKR: 'Rupia lankijska',
    LRD: 'Dolar liberyjski',
    LSL: 'Loti Lesotho',
    LYD: 'Dinar libijski',
    MAD: 'Dirham marokański',
    MDL: 'Lej mołdawski',
    MGA: 'Ariary madagaskarskie',
    MKD: 'Denar macedoński',
    MMK: 'Kiat birmański',
    MNT: 'Tugrik mongolski',
    MOP: 'Pataka Makau',
    MRO: 'Ugija mauretańska',
    MUR: 'Rupia Mauritiusa',
    MVR: 'Rufiyaa malediwska',
    MWK: 'Kwacha malawijska',
    MXN: 'Peso meksykańskie',
    MYR: 'Ringgit malezyjski',
    MZN: 'Metical mozambicki',
    NAD: 'Dolar namibijski',
    NGN: 'Naira nigeryjska',
    NIO: 'Cordoba nikaraguańska',
    NOK: 'Korona norweska',
    NPR: 'Rupia nepalska',
    NZD: 'Dolar nowozelandzki',
    OMR: 'Rial omański',
    PAB: 'Balboa panamski',
    PEN: 'Sol peruwiański',
    PGK: 'Kina papuaska',
    PHP: 'Peso filipińskie',
    PKR: 'Rupia pakistańskich',
    PLN: 'Złoty polski',
    PYG: 'Guarani paragwajskie',
    QAR: 'Rial katarski',
    RON: 'Lej rumuński',
    RSD: 'Dinar serbski',
    RUB: 'Rubel rosyjski',
    RWF: 'Frank rwandyjski',
    SAR: 'Rial saudyjski',
    SBD: 'Dolar Wysp Salomona',
    SCR: 'Rupia seszelska',
    SDG: 'Funt sudański',
    SEK: 'Korona szwedzka',
    SGD: 'Dolar singapurski',
    SHP: 'Funt Świętej Heleny',
    SLL: 'Leone sierraleoński',
    SOS: 'Szyling somalijski',
    SRD: 'Dolar surinamski',
    SSP: 'Funt południowosudański',
    STD: 'Dobra Wysp Świętego Tomasza i Książęcej',
    SVC: 'Colon salwadorski',
    SYP: 'Funt syryjski',
    SZL: 'Lilangeni Suazi',
    THB: 'Baht tajski',
    TJS: 'Somoni tadżyckie',
    TMT: 'Manat turkmeński',
    TND: 'Dinar tunezyjski',
    TOP: 'Paʻanga tongijska',
    TRY: 'Lira turecka',
    TTD: 'Dolar Trynidadu i Tobago',
    TWD: 'Dolar nowotajwański',
    TZS: 'Szyling tanzański',
    UAH: 'Hrywna ukraińska',
    UGX: 'Szyling ugandyjski',
    USD: 'Dolar amerykański',
    UYU: 'Peso urugwajskie',
    UZS: 'Sum uzbecki',
    VEF: 'Boliwar wenezuelski',
    VND: 'Dong wietnamski',
    VUV: 'Vatu Vanuatu',
    WST: 'Tala samoańska',
    YER: 'Rial jemeński',
    ZAR: 'Rand południowoafrykański',
    ZMW: 'Kwacha zambijska',
    ZWL: 'Dolar Zimbabwe'
  },
  countries: {
    AF: 'Afganistan',
    AX: 'Wyspy Alandzkie',
    AL: 'Albania',
    DZ: 'Algieria',
    AS: 'Samoa Amerykańskie',
    AD: 'Andora',
    AO: 'Angola',
    AI: 'Anguilla',
    AQ: 'Antarktyka',
    AG: 'Antigua i Barbuda',
    AR: 'Argentyna',
    AM: 'Armenia',
    AW: 'Aruba',
    AU: 'Australia',
    AT: 'Austria',
    AZ: 'Azerbejdżan',
    BS: 'Bahamy',
    BH: 'Bahrajn',
    BD: 'Bangladesz',
    BB: 'Barbados',
    BY: 'Białoruś',
    BE: 'Belgia',
    BZ: 'Belize',
    BJ: 'Benin',
    BM: 'Bermudy',
    BT: 'Bhutan',
    BO: 'Boliwia, Wielonarodowe Państwo Boliwia',
    BQ: 'Bonaire, Sint Eustatius i Saba',
    BA: 'Bośnia i Hercegowina',
    BW: 'Botswana',
    BV: 'Wyspa Bouveta',
    BR: 'Brazylia',
    IO: 'Brytyjskie Terytorium Oceanu Indyjskiego',
    BN: 'Brunei',
    BG: 'Bułgaria',
    BF: 'Burkina Faso',
    BI: 'Burundi',
    KH: 'Kambodża',
    CM: 'Kamerun',
    CA: 'Kanada',
    CV: 'Republika Zielonego Przylądka',
    KY: 'Kajmany',
    CF: 'Republika Środkowoafrykańska',
    TD: 'Czad',
    CL: 'Chile',
    CN: 'Chiny',
    CX: 'Wyspa Bożego Narodzenia',
    CC: 'Wyspy Kokosowe',
    CO: 'Kolumbia',
    KM: 'Komory',
    CG: 'Kongo',
    CD: 'Demokratyczna Republika Konga',
    CK: 'Wyspy Cooka',
    CR: 'Kostaryka',
    CI: 'Wybrzeże Kości Słoniowej',
    HR: 'Chorwacja',
    CU: 'Kuba',
    CW: 'Curaçao',
    CY: 'Cypr',
    CZ: 'Republika Czeska',
    DK: 'Dania',
    DJ: 'Dżibuti',
    DM: 'Dominika',
    DO: 'Republika Dominikańska',
    EC: 'Ekwador',
    EG: 'Egipt',
    SV: 'Salwador',
    GQ: 'Gwinea Równikowa',
    ER: 'Erytrea',
    EE: 'Estonia',
    ET: 'Etiopia',
    FK: 'Falklandy (Malwiny)',
    FO: 'Wyspy Owcze',
    FJ: 'Fidżi',
    FI: 'Finlandia',
    FR: 'Francja',
    GF: 'Gujana Francuska',
    PF: 'Polinezja Francuska',
    TF: 'Francuskie Terytoria Południowe i Antarktyczne',
    GA: 'Gabon',
    GM: 'Gambia',
    GE: 'Gruzja',
    DE: 'Niemcy',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GR: 'Grecja',
    GL: 'Grenlandia',
    GD: 'Grenada',
    GP: 'Gwadelupa',
    GU: 'Guam',
    GT: 'Gwatemala',
    GG: 'Guernsey',
    GN: 'Gwinea',
    GW: 'Gwinea Bissau',
    GY: 'Gujana',
    HT: 'Haiti',
    HM: 'Wyspy Heard i McDonalda',
    VA: 'Stolica Apostolska (miasto Watykan)',
    HN: 'Honduras',
    HK: 'Hongkong',
    HU: 'Węgry',
    IS: 'Islandia',
    IN: 'Indie',
    ID: 'Indonezja',
    IR: 'Iran, Islamska Republika',
    IQ: 'Irak',
    IE: 'Irlandia',
    IM: 'Wyspa Man',
    IL: 'Izrael',
    IT: 'Włochy',
    JM: 'Jamajka',
    JP: 'Japonia',
    JE: 'Jersey',
    JO: 'Jordania',
    KZ: 'Kazachstan',
    KE: 'Kenia',
    KI: 'Kiribati',
    KP: 'Korea Północna',
    KR: 'Korea Południowa',
    KW: 'Kuwejt',
    KG: 'Kirgistan',
    LA: 'Laos, Ludowo-Demokratyczna Republika',
    LV: 'Łotwa',
    LB: 'Liban',
    LS: 'Lesotho',
    LR: 'Liberia',
    LY: 'Libia',
    LI: 'Liechtenstein',
    LT: 'Litwa',
    LU: 'Luksemburg',
    MO: 'Makau',
    MK: 'Macedonia Północna',
    MG: 'Madagaskar',
    MW: 'Malawi',
    MY: 'Malezja',
    MV: 'Malediwy',
    ML: 'Mali',
    MT: 'Malta',
    MH: 'Wyspy Marshalla',
    MQ: 'Martynika',
    MR: 'Mauretania',
    MU: 'Mauritius',
    YT: 'Majotta',
    MX: 'Meksyk',
    FM: 'Mikronezja, Stany Zjednoczone',
    MD: 'Mołdawia, Republika Mołdawii',
    MC: 'Monako',
    MN: 'Mongolia',
    ME: 'Czarnogóra',
    MS: 'Montserrat',
    MA: 'Maroko',
    MZ: 'Mozambik',
    MM: 'Mjanma (Birma)',
    NA: 'Namibia',
    NR: 'Nauru',
    NP: 'Nepal',
    NL: 'Holandia',
    NC: 'Nowa Kaledonia',
    NZ: 'Nowa Zelandia',
    NI: 'Nikaragua',
    NE: 'Niger',
    NG: 'Nigeria',
    NU: 'Niue',
    NF: 'Wyspa Norfolk',
    MP: 'Mariany Północne',
    NO: 'Norwegia',
    OM: 'Oman',
    PK: 'Pakistan',
    PW: 'Palau',
    PS: 'Palestyna',
    PA: 'Panama',
    PG: 'Papua-Nowa Gwinea',
    PY: 'Paragwaj',
    PE: 'Peru',
    PH: 'Filipiny',
    PN: 'Pitcairn',
    PL: 'Polska',
    PT: 'Portugalia',
    PR: 'Portoryko',
    QA: 'Katar',
    RE: 'Reunion',
    RO: 'Rumunia',
    RU: 'Rosja',
    RW: 'Rwanda',
    BL: 'Saint-Barthélemy',
    SH: 'Wyspa Świętej Heleny, Wyspa Wniebowstąpienia i Tristan da Cunha',
    KN: 'Saint Kitts i Nevis',
    LC: 'Saint Lucia',
    MF: 'Saint-Martin (Francja)',
    PM: 'Saint-Pierre i Miquelon',
    VC: 'Saint Vincent i Grenadyny',
    WS: 'Samoa',
    SM: 'San Marino',
    ST: 'Wyspy Świętego Tomasza i Książęca',
    SA: 'Arabia Saudyjska',
    SN: 'Senegal',
    RS: 'Serbia',
    SC: 'Seszele',
    SL: 'Sierra Leone',
    SG: 'Singapur',
    SX: 'Sint Maarten (Holandia)',
    SK: 'Słowacja',
    SI: 'Słowenia',
    SB: 'Wyspy Salomona',
    SO: 'Somalia',
    ZA: 'Republika Południowej Afryki',
    GS: 'Georgia Południowa i Sandwich Południowy',
    SS: 'Sudan Południowy',
    ES: 'Hiszpania',
    LK: 'Sri Lanka',
    SD: 'Sudan',
    SR: 'Surinam',
    SJ: 'Svalbard i Jan Mayen',
    SZ: 'Eswatini',
    SE: 'Szwecja',
    CH: 'Szwajcaria',
    SY: 'Syria',
    TW: 'Tajwan',
    TJ: 'Tadżykistan',
    TZ: 'Tanzania',
    TH: 'Tajlandia',
    TL: 'Timor Wschodni',
    TG: 'Togo',
    TK: 'Tokelau',
    TO: 'Tonga',
    TT: 'Trynidad i Tobago',
    TN: 'Tunezja',
    TR: 'Turcja',
    TM: 'Turkmenistan',
    TC: 'Turks i Caicos',
    TV: 'Tuvalu',
    UG: 'Uganda',
    UA: 'Ukraina',
    AE: 'Zjednoczone Emiraty Arabskie',
    GB: 'Wielka Brytania',
    US: 'Stany Zjednoczone',
    UM: 'Dalekie Wyspy Mniejsze Stanów Zjednoczonych',
    UY: 'Urugwaj',
    UZ: 'Uzbekistan',
    VU: 'Vanuatu',
    VE: 'Wenezuela',
    VN: 'Wietnam',
    VG: 'Brytyjskie Wyspy Dziewicze',
    VI: 'Wyspy Dziewicze Stanów Zjednoczonych',
    WF: 'Wallis i Futuna',
    EH: 'Sahara Zachodnia',
    YE: 'Jemen',
    ZM: 'Zambia',
    ZW: 'Zimbabwe'
  },
  states: {
    AL: 'Alabama',
    AK: 'Alaska',
    AZ: 'Arizona',
    AR: 'Arkansas',
    CA: 'California',
    CO: 'Colorado',
    CT: 'Connecticut',
    DE: 'Delaware',
    FL: 'Florida',
    GA: 'Georgia',
    HI: 'Hawaii',
    ID: 'Idaho',
    IL: 'Illinois',
    IN: 'Indiana',
    IA: 'Iowa',
    KS: 'Kansas',
    KY: 'Kentucky',
    LA: 'Louisiana',
    ME: 'Maine',
    MD: 'Maryland',
    MA: 'Massachusetts',
    MI: 'Michigan',
    MN: 'Minnesota',
    MS: 'Mississippi',
    MO: 'Missouri',
    MT: 'Montana',
    NE: 'Nebraska',
    NV: 'Nevada',
    NH: 'New Hampshire',
    NJ: 'New Jersey',
    NM: 'New Mexico',
    NY: 'New York',
    NC: 'North Carolina',
    ND: 'North Dakota',
    OH: 'Ohio',
    OK: 'Oklahoma',
    OR: 'Oregon',
    PA: 'Pennsylvania',
    RI: 'Rhode Island',
    SC: 'South Carolina',
    SD: 'South Dakota',
    TN: 'Tennessee',
    TX: 'Texas',
    UT: 'Utah',
    VT: 'Vermont',
    VA: 'Virginia',
    WA: 'Washington',
    WV: 'West Virginia',
    WI: 'Wisconsin',
    WY: 'Wyoming'
  },
  inlineEdit: {
    save: 'Zapisz',
    cancel: 'Anuluj'
  },
  formPageLayout: {
    discard: 'Odrzuć i wróć'
  },
  multiSelect: {
    clearAll: 'Wyczyść wszystko'
  },
  filterMultiSelect: {
    andMore: 'i {{count}} więcej'
  },
  inlineEditTrigger: {
    edit: 'Edytuj'
  },
  searchSelect: {
    noOptions: 'Brak opcji'
  },
  cardDetails: {
    title: 'Szczegóły karty: x{{lastDigits}}',
    detailsHeader: 'Szczegóły karty',
    data: {
      number: 'Numer karty',
      holder: 'Właściciel karty',
      expiryDate: 'Data wygaśnięcia'
    },
    billingInformation: 'Informacje o płatności',
    billingAddress: 'Adres rozliczeniowy',
    vatNumber: 'Numer VAT',
    closeCardDetails: 'Zamknij szczegóły karty',
    copyNumber: 'Skopiuj numer',
    copied: 'Skopiowane'
  },
  addressPicker: {
    enterAddressManually: 'Nie widzisz swojego adresu? Wprowadź ręcznie'
  },
  panelDocumentInfo: {
    download: 'Pobierz',
    noDocument: 'Dokument nie został przesłany'
  },
  accountBalances: {
    availableBalance: 'Dostępne saldo'
  },
  payAccountlayout: {
    loading: 'Ładowanie...',
    select: 'Wybierz'
  }
};
exports.default = _default;